export const getPolicyName = (authPolicyDetails) => {
  return authPolicyDetails.policy.name;
};